import request from '@/utils/request'

// 查询登录日志列表
export function list (query) {
  return request({
    url: '/message/log/list',
    method: 'get',
    params: query
  })
}

export const copy = (data) => {
  return new Promise((resolve, reject) => {
    const url = data
    const oInput = document.createElement('input')
    oInput.value = url
    document.body.appendChild(oInput)
    oInput.select() // 选择对象;
    document.execCommand('Copy') // 执行浏览器复制命令
    // this.$message.success('已复制！')
    oInput.remove()
    resolve(`复制成功：${data}`)
  })
}

export function restart (query) {
  return request({
    url: '/message/log/restart',
    method: 'get',
    params: query
  })
}
